import {
  Component,
  HostListener,
  inject,
  LOCALE_ID,
  OnInit,
  signal,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { ButtonAtomComponent } from '../../../../../libs/shared/components/src/lib/components/atoms/button-atom/button-atom.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter, startWith } from 'rxjs';
// import { of } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MenubarModule, ButtonAtomComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  items: MenuItem[] = [];
  menuActive: boolean = false;
  router = inject(Router);

  title = '';
  // baseHref = document.getElementsByTagName('base')[0].getAttribute('href');
  // languagePrefix = this.baseHref?.replaceAll('/', '') || 'es';
  languagePrefix = inject(LOCALE_ID);
  showLoginButton = signal(true);

  currentPath = window.location.pathname
    .replace('/es/', '')
    .replace('/en/', '');

  localeFlagKey: { es: string; en: string; de: string } = {
    es: 'es',
    en: 'uk',
    de: 'de',
  };

  ngOnInit() {
    const languageMenu = [];
    this.languagePrefix !== 'es' &&
      languageMenu.push({
        // label: 'Inglés',
        label:
          '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
        styleClass: 'flag-menu',
        url: '/es/',
        target: '_self',
      });

    this.languagePrefix !== 'en' &&
      languageMenu.push({
        // label: 'Inglés',
        label:
          '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
        styleClass: 'flag-menu',
        url: '/en/',
        target: '_self',
      });

    this.languagePrefix !== 'de' &&
      languageMenu.push({
        label:
          '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-de">',
        styleClass: 'flag-menu',
        url: '/de/',
        target: '_self',
      });
    // ? {

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        startWith(new NavigationEnd(0, this.router.url, this.router.url))
      )
      .subscribe(event => {
        const url = event.urlAfterRedirects || event.url;
        const isAreaCliente = url.includes('area-cliente');
        this.showLoginButton.set(!isAreaCliente);
      });

    this.items = [
      // {
      //   label: $localize`:@@header.menu.home.label:Inicio`,
      //   // routerLink: '/',
      //   url: `${this.baseHref}` + $localize`:@@header.menu.home.path:home`,
      //   target: '_self',
      //   styleClass: ['', 'inicio', 'home'].includes(this.currentPath)
      //     ? 'active'
      //     : '',
      // },
    ];

    // this.languagePrefix != 'de' &&
    //   this.items.push({
    //     label: $localize`:@@header.menu.productos.label:Seguros de Buceo`,
    //     routerLink: '/seguro-buceo',
    //   });

    // this.items.push(
    //   {
    //     label: $localize`:@@header.menu.scubamedic.label:Scubamedic`,
    //     routerLink: '/scubamedic',
    //   },
    //   {
    //     label: $localize`:@@header.menu.dive-pro.label:DIVE PRO`,
    //     routerLink: '/dive-pro',
    //   },
    //   {
    //     label: $localize`:@@header.menu.customer-area.label:Area cliente`,
    //     routerLink: '/area-cliente',
    //   },
    //   {
    //     label: $localize`:@@header.menu.sinister.label:En caso de accidente`,
    //     routerLink: '/caso-accidente',
    //   }
    // );

    // this.items.push(
    //   {
    //     label: $localize`:@@header.menu.contact.label:Contacto`,
    //     routerLink: '/contacto',
    //   }
    //   // {
    //   //   label: $localize`:@@header.menu.dive-center-access.label:Acceso centros de buceo`,
    //   //   routerLink: '/login',
    //   // }
    // );

    this.items
      .push
      // {
      //   label: `<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-${
      //     (this.localeFlagKey as any)[this.languagePrefix]
      //   }">`,
      //   // label: `Idioma`,
      //   icon: '',
      //   items: [
      //     // this.languagePrefix == 'en'
      //     //   ? {
      //     //       // label: 'Inglés',
      //     //       label:
      //     //         '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
      //     //       styleClass: 'flag-menu',
      //     //       url: '/en/',
      //     //       target: '_self',
      //     //     }
      //     //   : {
      //     //       // label: 'Inglés',
      //     //       label:
      //     //         '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
      //     //       styleClass: 'flag-menu',
      //     //       url: '/en/',
      //     //       target: '_self',
      //     //     },
      //     this.languagePrefix !== 'es'
      //       ? {
      //           // label: 'Inglés',
      //           label:
      //             '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
      //           styleClass: 'flag-menu',
      //           url: '/es/',
      //           target: '_self',
      //         }
      //       : of(''),
      //     this.languagePrefix !== 'en'
      //       ? {
      //           // label: 'Inglés',
      //           label:
      //             '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
      //           styleClass: 'flag-menu',
      //           url: '/en/',
      //           target: '_self',
      //         }
      //       : of(''),
      //     this.languagePrefix !== 'de'
      //       ? {
      //           // label: 'Inglés',
      //           label:
      //             '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-de">',
      //           styleClass: 'flag-menu',
      //           url: '/de/',
      //           target: '_self',
      //         }
      //       : of(''),
      //   ],
      // }
      // {
      //   // label: 'Inglés',
      //   label:
      //     '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
      //   styleClass: '',
      //   url: '/en/',
      //   target: '_self',
      // },
      // {
      //   label: `<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-${this.languagePrefix}">`,

      //   styleClass: '',
      //   url: this.languagePrefix,
      //   target: '_self',
      // },
      ();
  }

  controlOverflow() {
    const mobileActive = document.body.querySelector('.p-menubar');
    mobileActive?.classList.contains('p-menubar-mobile-active')
      ? document.body.classList.add('p-overflow-hidden')
      : document.body.classList.remove('p-overflow-hidden');

    if (window.innerWidth > 960) {
      document.body.classList.remove('p-overflow-hidden');
    }
  }

  toggleMenu() {
    this.controlOverflow();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    // event: Event

    this.controlOverflow();
  }

  private updateButtonVisibility(url: string) {
    const isAreaCliente = url.includes('area-cliente');
    this.showLoginButton.set(!isAreaCliente);
  }
}
